import EventEmitter from 'events';
import type TypedEventEmitter from 'typed-emitter';
import type { SdkGameEvent } from '../../events/gameEvent';

export type SdkGameEvents = {
  [key: string]: (e: SdkGameEvent) => void;
};

export const SdkGameEventsEmitter = new EventEmitter() as TypedEventEmitter<SdkGameEvents>;
